import {
  Tooltip as TooltipBase,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import {
  type TooltipContentProps,
  type TooltipTriggerProps,
  type TooltipProps,
} from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';

export type SharedTooltipProps = {
  content: string | ReactNode;
  children: TooltipTriggerProps['children'];
  position?: TooltipContentProps['side'];
  triggerProps?: Omit<TooltipTriggerProps, 'children'>;
  contentProps?: Omit<TooltipContentProps, 'children'>;
  baseProps?: Pick<TooltipProps, 'delayDuration' | 'disableHoverableContent'>;
};

export const SharedTooltip = ({
  content,
  children,
  position,
  contentProps,
  triggerProps,
  baseProps,
}: SharedTooltipProps) => {
  return (
    <TooltipBase {...baseProps}>
      <TooltipTrigger asChild {...triggerProps}>
        {children}
      </TooltipTrigger>
      <TooltipContent side={position} {...contentProps}>
        {content}
      </TooltipContent>
    </TooltipBase>
  );
};
